/* eslint-disable react/jsx-no-target-blank */
import "../css/ErrorView.css"
import { ReactComponent as ExclamationMark } from "../icon/exclamation.svg";
import frills from '../icon/frills.svg';

interface ErrorViewProps {
  code: number
}

export default function ErrorView({ code }: ErrorViewProps) {
  let title = "Live Feed Issue"
  let message = "Something went wrong!"
  let callToAction = {
    message: "Visit Help Center",
    link: "https://help.simplebooth.com/en/articles/1120144-how-does-live-feed-work"
  }

  if (code === 404) {
    message = "We can't seem to find that gallery. It may be deleted, private, or an incorrect link."
  }

  if (code === 500) {
    message = "Something went wrong, please refresh and try again. Reach out to support@simplebooth.com if the problem persists."
  }

  if (code === 401) {
    title = "Subscription Required"
    message = "Live Feed is not available on this account, but the owner can subscribe to gain access."
    callToAction = {
      message: "Manage My Plan",
      link: "https://www.simplebooth.com/subscription"
    }
  }

  return (
    <div className="errorView">
      <div className="frillsContainer">
        <img src={frills} alt="" />
        <div className="bobbingIconContainer">
          <ExclamationMark />
        </div>
      </div>
      <h2>{title}</h2>
      <p>{message}</p>
      <a className="help" href={callToAction.link} target="_blank">{callToAction.message}</a>
    </div>
  )
}